import React from "react"
import { motion } from "motion/react"

import { ISubPageProps } from "../../context"
import { useMaskCanvas } from "./hooks/useMaskCanvas"
import GameLayer from "./scene"

import styles from "./index.module.less"

const PageGame: React.FC<ISubPageProps> = ({ onExit }) => {
    const canvasRef = useMaskCanvas()

    return (
        <motion.div
            className={styles.pageGame}
            initial={{
                opacity: 0,
                pointerEvents: "none",
            }}
            animate={{
                opacity: 1,
                pointerEvents: "auto",
            }}
            exit={{
                opacity: 0,
                pointerEvents: "none",
            }}
            transition={{
                duration: 0.5,
                ease: "easeInOut",
            }}
        >
            <GameLayer back={onExit} />
            <canvas className={styles.mask} ref={canvasRef} />
        </motion.div>
    )
}

export default PageGame
